export enum enumIsfStatusTab {
  ALL,
  DRAFTS,
  CORRECTIONS_REQUIRED,
  APPROVED,
}
